module.exports = __webpack_public_path__ + "static/campus-map.a2fb9995.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/campus-map.png
// module id = 493
// module chunks = 54681204059826